import * as React from "react";
import PropTypes from "prop-types";
const SvgNavigationMoreHighlightedXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M4.75 8a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zM10.25 8a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zM13.5 10.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z" />
      </g>
    </svg>
  )
);
SvgNavigationMoreHighlightedXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgNavigationMoreHighlightedXsmall;
